import { tankWidthPx } from './tank'

/**
 * How big the rings are for a viewport. World units follow the viewport's height, so on tall
 * screens and narrow ones the title is small and a full-size ring would dwarf the letters; the
 * rings shrink with it, and keep shrinking as the window does.
 */
export function ringScaleFor(width: number, height: number): number {
  return Math.max(0.45, Math.min(1, 900 / height, width / 1500))
}

export function ringSizesFor(width: number, height: number): { minSize: number; maxSize: number; size0: number } {
  const k = ringScaleFor(width, height)
  // A little smaller than the letters would allow: a heap of big rings jams itself on the title.
  return { minSize: 0.62 * k, maxSize: 0.78 * k, size0: 0.7 * k }
}

/** The world is this many units tall whatever the viewport (camera distance 35, field of view 30°). */
const WORLD_HEIGHT = 2 * Math.tan((30 * Math.PI) / 360) * 35

/**
 * How many rings fill a viewport: enough for about six rows across the tank's width, so the
 * pile is a pile on a phone as well as on a wide screen, within what the physics can afford.
 */
export function ringCountFor(width: number, height: number, touch = false): number {
  const { maxSize } = ringSizesFor(width, height)
  const worldWidth = WORLD_HEIGHT * (tankWidthPx(width, height) / height)
  const perRow = worldWidth / (2 * maxSize)
  // Phones and tablets get fewer: collisions are the one cost that grows with the square of the count.
  const ceiling = touch ? 100 : 150
  return Math.round(Math.min(ceiling, Math.max(60, perRow * 6)))
}
